/**
 * The platform's one look for clickable list cards (Document Panel, Human
 * Review Queue, Health Concerns, Timeline, Medications, Diagnostics), taken
 * from the Recent Medical Records Uploads rows:
 *
 *  - resting:  1px gray border, white
 *  - hover:    border stays gray, faint pink fill
 *  - selected: 1px pink border (#F36F8F at 40%) + the same faint pink fill
 *
 * The pink border marks the selected card only. Classes are `!important` so
 * they win over antd Button's own border/background.
 */
const BASE = "!border !bg-white transition-colors";
const RESTING = "!border-[#E5E7EB] hover:!border-[#E5E7EB] hover:!bg-[#FFF9FA]";
const SELECTED = "!border-[#F36F8F]/40 !bg-[#FFF9FA] hover:!border-[#F36F8F]/40 hover:!bg-[#FFF9FA]";

/** Border + background classes for a list card, selected or not. */
export function listCardClass(selected = false): string {
  return `${BASE} ${selected ? SELECTED : RESTING}`;
}
